<template>
  <PageTemplate title="Política de Privacidade">
    <template #before>
      <router-link to="/" class="d-flex justify-center mb-12">
        <img
          :src="files + informations.img"
          height="40px"
          class="filter-white"
          alt=""
        />
      </router-link>
    </template>
    <PolicyPrivacyWidget />
  </PageTemplate>
</template>

<script>
import PageTemplate from "../components/templates/PageTemplate.vue";
import PolicyPrivacyWidget from "../components/widgets/PolicyPrivacyWidget.vue";

export default {
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
  },
  components: {
    PageTemplate,
    PolicyPrivacyWidget,
  },
};
</script>

<style></style>
